export const AI_SERVICES_CHUNK = 'Ai';
